import { ReportingControllerBaseConfig } from '../../base';
import { ReportGenerateController } from './reportHomeInterface';
import { ReportGenerateViewProps } from './reportHomeProps';
import { useRef, ChangeEventHandler } from 'react';
import { ensureFileArray } from './reportHomeHelper';

export function createReportGenerateController(
    config: ReportingControllerBaseConfig
): ReportGenerateController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;
    const formController = createFormController({
        submitOnEnter: true,
    });
    return {
        useProps(context, item, props): ReportGenerateViewProps {
            const form = formController.useProps(props.form);
            const attachButtonRef = useRef<HTMLButtonElement>(null);
            const fileInputRef = useRef<HTMLInputElement>(null);
            const watchedFiles = props.form.form.watch('files');
            const selectedFilesArray = ensureFileArray(watchedFiles);

            const {
                ref: registerInputRefCallback,
                onChange: rhfOnChange,
                ...restRegisterProps
            } = props.form.form.register('files');

            const handleButtonClick = () => {
                fileInputRef.current?.click();
            };

            const handleInputChange: ChangeEventHandler<HTMLInputElement> = async (
                event
            ) => {
                await rhfOnChange(event);
                attachButtonRef.current?.blur();
            };

            const handleRemoveFile = (index: number) => {
                const currentFilesValue = props.form.form.getValues('files');
                const currentFilesArray = ensureFileArray(currentFilesValue);
                const updatedFiles = currentFilesArray.filter((_, i) => i !== index);
                props.form.form.setValue('files', updatedFiles, {
                    shouldValidate: true,
                    shouldDirty: true,
                });
            };

            return {
                form,
                field: {
                    question: {
                        input: form.form.register('question'),
                    },
                },
                submit: {
                    button: {
                        ...form.getSubmitButtonProps(),
                        isDisabled: props.values.question.trim().length === 0,
                    },
                },
                fileInput: {
                    ref: fileInputRef,
                    selectedFiles: selectedFilesArray,
                    button: {
                        ref: attachButtonRef,
                        onClick: handleButtonClick,
                        'aria-label': 'Attach file',
                    },
                    inputProps: {
                        ...restRegisterProps,
                        ref: (e: HTMLInputElement | null) => {
                            registerInputRefCallback(e);
                            (
                                fileInputRef as React.MutableRefObject<HTMLInputElement | null>
                            ).current = e;
                        },
                        onChange: handleInputChange,
                    },
                    onRemoveFile: handleRemoveFile,
                },
                options: {
                    container: {
                        onSubmit(values) {
                            props.disclosure.onClose();
                        },
                    },
                    popover: {
                        isOpen: props.disclosure.isOpen,
                        onClose: props.disclosure.onClose,
                        onOpen: props.disclosure.onOpen,
                    },
                },
                template: {
                    value: props.values.template,
                    onChange(item) {
                        props.form.form.setValue('template', item);
                    },
                },
            };
        },
    };
}
